import {apiFetch} from 'src/api/fetch'
import {toBusinessApiDateString} from 'src/jobs/job-schedule-format'

import {
    type RentalBillingChargeCreateInput,
    rentalBillingChargeCreateInputSchema,
    type RentalBillingChargesResponse,
    rentalBillingChargesResponseSchema,
    type RentalBillingPreview,
    rentalBillingPreviewSchema,
} from './schemas'

export async function getRentalBillingPreview(
    jobId: string,
    billThrough: Date | string,
): Promise<RentalBillingPreview> {
    const raw = await apiFetch<unknown>(
        `/jobs/${jobId}/rental-billing-preview?bill_through=${toBusinessApiDateString(billThrough)}`,
    )
    return rentalBillingPreviewSchema.parse(raw)
}

export async function createRentalBillingCharges(
    jobId: string,
    input: RentalBillingChargeCreateInput,
): Promise<RentalBillingChargesResponse> {
    const parsed = rentalBillingChargeCreateInputSchema.parse(input)
    const raw = await apiFetch<unknown>(`/jobs/${jobId}/rental-billing-charges`, {
        method: 'POST',
        body: JSON.stringify({
            bill_through: toBusinessApiDateString(parsed.billThrough),
            rental_stint_ids: parsed.rentalStintIds,
        }),
    })
    return rentalBillingChargesResponseSchema.parse(raw)
}

export async function getProjectRentalBillingPreview(
    projectId: string,
    billThrough: Date | string,
    rentalStintIds?: string[],
): Promise<RentalBillingPreview> {
    const stintQuery = rentalStintIds
        ?.map((id) => `rental_stint_ids=${encodeURIComponent(id)}`)
        .join('&')
    const query = [`bill_through=${toBusinessApiDateString(billThrough)}`, stintQuery]
        .filter(Boolean)
        .join('&')
    const raw = await apiFetch<unknown>(`/projects/${projectId}/rental-billing-preview?${query}`)
    return rentalBillingPreviewSchema.parse(raw)
}

export async function createProjectRentalBillingCharges(
    projectId: string,
    input: RentalBillingChargeCreateInput,
): Promise<RentalBillingChargesResponse> {
    const parsed = rentalBillingChargeCreateInputSchema.parse(input)
    const raw = await apiFetch<unknown>(`/projects/${projectId}/rental-billing-charges`, {
        method: 'POST',
        body: JSON.stringify({
            bill_through: toBusinessApiDateString(parsed.billThrough),
            rental_stint_ids: parsed.rentalStintIds,
        }),
    })
    return rentalBillingChargesResponseSchema.parse(raw)
}
